const validatePhone = (phone, re) => {
    if (!re || !Array.isArray(re)) {
        var re = re || /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g; // passes: 111-111-1111
        return re.test(phone);
    }
    if (Array.isArray(re)) {
        for (let i = 0; i < re.length; i++) {
            if (typeof re[i] === 'object' && re[i].regex) {
                const result = re[i].regex.test(phone);
                // if minLength is not defined, consider length > 0 as phone no
                if (result &&
                    phone.replace(/[^0-9]/g, '').length >= (re[i].minLimit ? re[i].minLimit : 0)) {
                    return result;
                }
            }
        }
    }
    return false;
};
export default validatePhone;
